import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import * as Util from '@src/shared/util-common';
import { ExtractDataRepository } from '@src/data/repository/extract-repository/extract.repository';
import { ExtractRequest } from '@src/core/domain/extract/extract.model';
import { RolesService } from '@src/shared/services/roles.service';
import { GetNewTokenExtractUsecase } from '@src/core/usecases/token/get-new-token-extract-usecase';
import { TokenTypeModel } from '@src/core/domain/token/tokenType.model';
import { ListComponent } from '@src/presentation/web/components/lists/list.component';
import { ShowValuesDashboardDataShare } from '@src/data/repository/data-share-repository';
import { ToastErrorMessageComponent } from '../../components/toast-error-message/toast-error-message.component';

@Component({
  selector: 'fibra-page-extract',
  templateUrl: './extract.component.html',
  styleUrls: ['./extract.component.scss'],
})
export class ExtractComponent implements AfterViewInit {
  @ViewChild(ToastErrorMessageComponent, { static: false }) toast: ToastErrorMessageComponent;
  @ViewChild(ListComponent, null) list: ListComponent;

  public menu = [
      'Visão Geral',
      'Agendamento',
      //'Extratos consolidados'
  ];
  public view: string = 'view-1';
  public noPermission = {
    icon: 'empty',
    title: 'Extrato indisponível no momento',
    description: 'Para acessar o extrato dessa conta entre em contato com o seu gerente de relacionamento.'
  }
  public mainPrefix = 'view';
  public loading: boolean = true;
  public token = undefined;
  public report = false;
  private _showData = false;
  public typToastColor;
  public REDCOLOR = '#ED6C6C';
  public GREENCOLOR = '#73B599';

  constructor(
    private authService: MsalService,
    private extractRepository: ExtractDataRepository,
    private rolesService: RolesService,
    private getNewTokenExtract: GetNewTokenExtractUsecase,
    private _shareShowValues: ShowValuesDashboardDataShare
  ) {}

  ngOnInit() {
    this._shareShowValues.dataShared.subscribe( res => {
      this._showData = res &&  res.iconEyesOpen
    });

    this.init();
  }

  ngAfterViewInit() {
  }

  private init = () => {
    if (this.rolesService.get().includes('EXT.CONS_EXT_SAL') && !this.rolesService.get().includes('MASTER')) {
      this.getNewTokenExtract.execute().pipe(finalize(() => this.loading = false)).subscribe((response: TokenTypeModel) => {
        sessionStorage.setItem('x-ibpj-session', response.data.sessionToken);
      });
    } else {
      this.loading = false;
    }

    this.reviewToken();
  }

  public changePage(page): void {
    this.view = page;
  }

  private reviewToken() {
    this.token = sessionStorage.getItem('accessToken');
    if (!this.token) {
      this.authService.logout();
    }
  }

  public exportScreen(res) {

    if (res.value === 1) {      
      this.exportPDF();
    } else {
      this.exportExcel()
    }
  }

  public exportPDF() {
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    };

    const locale = 'pt-br';
    let dateReport = new Date().toLocaleDateString(locale, options);

    let extractInfo = sessionStorage.getItem('extract_info');
    const filter = JSON.parse(extractInfo);
    const params: ExtractRequest = {
      dataInicio: filter.dataInicio,
      dataFinal: filter.dataFinal,
      tipo: filter.tipo,
      showAmmouts: this._showData ? 'true' : 'false',
      periodShow: 'false'
    };

    let errorMessage = 'Erro ao tentar fazer download do arquivo, tente mais tarde.';

      this.extractRepository.getPDF(params).subscribe(
      res => {
        //debugger
        Util.handleFile(res, `Extrato-${dateReport}`, 'pdf');
        this.typToastColor = this.GREENCOLOR;
        this.toast.callModalMessage(null, 'Arquivo baixado com sucesso.');
      }, 
      () => {
        this.typToastColor = this.REDCOLOR;
        this.toast.callModalMessage(null, 'Ocorreu um erro ao tentar baixar o arquivo.');
        //alert(errorMessage)
      });
  }

    public exportExcel() {

      const options = {
        year: 'numeric',
        month: '2-digit',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
    }
      const locale = 'pt-br'
      let dateReport = new Date().toLocaleDateString(locale, options)
      let filter = JSON.parse(sessionStorage.getItem('extract_info'));
      
      const param: ExtractRequest = {
        dataInicio: filter.dataInicio,
        dataFinal: filter.dataFinal,
      }
      let errorMessage='Erro ao tentar fazer download do arquivo, tente mais tarde.'
      switch (filter.tipo) {
        case 'tudo':
          this.extractRepository.postExportExcelTotal(param).subscribe((res) => {
            Util.consoleDev('res', res)
            Util.handleFile(res, `Extrato-${dateReport}`);
            this.typToastColor = this.GREENCOLOR;
            this.toast.callModalMessage(null, 'Arquivo baixado com sucesso.');
          }, error => {
            this.typToastColor = this.REDCOLOR;
            this.toast.callModalMessage(null, 'Ocorreu um erro ao tentar baixar o arquivo.');
            //alert(errorMessage)
            Util.consoleDev('Erro:', error)
          });
          break;

        case 'saida':
          this.extractRepository.postExportExcelSaida(param).subscribe((res) => {
            Util.handleFile(res, `Extrato-${dateReport}`);
            this.typToastColor = this.GREENCOLOR;
            this.toast.callModalMessage(null, 'Arquivo baixado com sucesso.');
          }, error => {
            this.typToastColor = this.REDCOLOR;
            this.toast.callModalMessage(null, 'Ocorreu um erro ao tentar baixar o arquivo.');
            //alert(errorMessage)
            Util.consoleDev('Erro:', error)
          });
          break;
        case 'entrada':
          this.extractRepository.postExportExcelEntrada(param).subscribe((res) => {
            Util.handleFile(res, `Extrato-${dateReport}`);
            this.typToastColor = this.GREENCOLOR;
            this.toast.callModalMessage(null, 'Arquivo baixado com sucesso.');
          }, error => {
            this.typToastColor = this.REDCOLOR;
            this.toast.callModalMessage(null, 'Ocorreu um erro ao tentar baixar o arquivo.');
            //alert(errorMessage)
            Util.consoleDev('Erro:', error)
          });
          break;

        case 'agendadas':
          this.extractRepository.postExportExcelAgendadas(param).subscribe((res) => {
            Util.handleFile(res, `Extrato-${dateReport}`);
            this.typToastColor = this.GREENCOLOR;
            this.toast.callModalMessage(null, 'Arquivo baixado com sucesso.');
          }, error => {
            this.typToastColor = this.REDCOLOR;
            this.toast.callModalMessage(null, 'Ocorreu um erro ao tentar baixar o arquivo.');
            //alert(errorMessage)
            Util.consoleDev('Erro:', error)
          });
          break;


        default:
          this.extractRepository.postExportExcelTotal(param).subscribe((res) => {
            Util.handleFile(res, `Extrato-${dateReport}`);
            this.typToastColor = this.GREENCOLOR;
            this.toast.callModalMessage(null, 'Arquivo baixado com sucesso.');
          }, error => {
            this.typToastColor = this.REDCOLOR;
            this.toast.callModalMessage(null, 'Ocorreu um erro ao tentar baixar o arquivo.');
            //alert(errorMessage)
            Util.consoleDev('Erro:', error)
          });
          break;
      }
  }


  public changeReportView(event) {
    this.report = !this.report;
  }
}
